(function() {
    $(document).ready(function() {
        window.c24LpCssLoaded.then(function () {

            const calcHeights = function() {
                $('.js24ContentTeaser').each((_, teaser) => {
                    const $teaser = $(teaser);
                    const $cut = $('.cut', $teaser);
                    const isOpen = $teaser.hasClass('open');

                    if (isOpen) {
                        $teaser.removeClass('open');
                    }

                    $teaser.css({
                        height: '',
                    });

                    const cutTop = $cut.offset().top + $cut.height();

                    $teaser.data('initial-height', $teaser.height() + 10);
                    $teaser.data('closed-height', cutTop - $teaser.offset().top);

                    if (isOpen) {
                        $teaser.addClass('open');

                        $teaser.css({
                            height: $teaser.data('initial-height'),
                        });

                    } else {
                        $teaser.css({
                            height: $teaser.data('closed-height'),
                        });
                    }
                });
            };

            calcHeights();
            $(window).on('resize', calcHeights);

            $('.js24ContentTeaser').on('click', function(event) {
                const $teaser = $(this);

                if ($teaser.hasClass('contentCut')) {
                    const $clickedElement = $(event.target);
                    const $content = $('.content', $teaser);
                    const contentIsTrigger = $content?.data('isTrigger');
                    const isContentCutHeader = $clickedElement.hasClass('contentCutHeader');
                    const isContent = $clickedElement.hasClass('content');
                    const isInsideContent = $content[0].contains($clickedElement[0]);

                    if (!contentIsTrigger && !isContentCutHeader) {
                        return;
                    }

                    if (!isContentCutHeader && !isContent && !isInsideContent) {
                        return;
                    }
                }

                if ($teaser.hasClass('open')) {
                    $teaser.removeClass('open');

                    $teaser.animate({
                        height: $teaser.data('closed-height'),
                    }, 500);

                    if (window.c24LpIsMobile) {
                        $('body,html').animate(
                            {
                                scrollTop: Math.max($teaser.offset().top - 60, 10),
                            },
                            500,
                        );
                    }

                } else {
                    $teaser.addClass('open');

                    $teaser.animate({
                        height: $teaser.data('initial-height'),
                    }, 500);
                }
            });
        });
    });
})();
